import Image from 'next/future/image';
import { getEdgeUrl } from '@/lib/getEdgeUrl';

const Content = () => (
  <div className="flex w-full items-center justify-center lg:w-1/2">
    <div className="">
      <h4 className="text-gray-700/75">
        Did you know Reebelo is a marketplace?
      </h4>
      <h2 className="mt-1 text-xl font-bold leading-tight md:text-2xl">
        We connect buyers with a network of sellers that renew & certify
        sustainable products
      </h2>
      <div className="mt-5 space-y-5 sm:mt-8 sm:space-y-8">
        <p>
          Because several vendors may be selling the same items, our marketplace
          drives prices to a competitive low. We're committed to making
          sustainable shopping easy, rewarding, and enjoyable with deep
          discounts on top brands & daily deals from 100+ global sellers.
        </p>
        <p>
          We vet every seller, their refurbishing expertise, commitment to
          sustainability, and their ability to fulfill orders timely. So you
          only choose from the very best while helping the environment.
        </p>
        <p>For your planet & your pocket - we promise to care for both.</p>
      </div>
    </div>
  </div>
);

const Asset = () => (
  <div className="mx-auto flex items-center justify-center md:w-full lg:w-1/2 lg:justify-end">
    <Image
      src={getEdgeUrl('images/about-us/marketplace/right.png')}
      alt="Vendors"
      className="h-full w-auto object-contain"
      height={1200}
      width={1000}
      quality={100}
    />
  </div>
);

const Marketplace = () => (
  <section className="bg-white">
    <div className="reebelo-container py-10 sm:py-16">
      <div className="flex flex-col-reverse gap-5 sm:gap-8 lg:flex-row">
        <Content />
        <Asset />
      </div>
    </div>
  </section>
);

export default Marketplace;
